import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import ModalActionDialog from 'components/modals/dialogs/modal-action-dialog'

const UpdateSuccess = () => {
  const navigate = useNavigate()
  const onClose = () => navigate('/settings/billing')

  return (
    <ModalActionDialog
      type="success"
      header="Success!"
      submitButtonCaption="Ok"
      onSubmit={onClose}
      onClose={onClose}
    >
      Thanks! Your payment details have been updated.
    </ModalActionDialog>
  )
}

export default UpdateSuccess
